
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/daftar-bimbel",
      function () {
        return require("private-next-pages/daftar-bimbel.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/daftar-bimbel"])
      });
    }
  